<script lang="ts" setup>
import type { Component, Document, Page } from '@bloomreach/spa-sdk'
import { ref, toRefs } from 'vue'

import facebookIcon from '@/assets/icons/blog/fb.svg'
import instagramIcon from '@/assets/icons/blog/ig.svg'
import linkedInIcon from '@/assets/icons/blog/in.svg'
import xIcon from '@/assets/icons/blog/x.svg'
import youTubeIcon from '@/assets/icons/blog/yt.svg'

interface TSocialMedia {
    icon: string
    url: string
}

type IconType = 'social-facebook' | 'social-instagram' | 'social-linkedin' | 'social-x-twitter' | 'social-youtube'

const props = defineProps<{
    data: TSocialMedia[]
}>()

const iconMap = {
    'social-facebook': facebookIcon,
    'social-instagram': instagramIcon,
    'social-linkedin': linkedInIcon,
    'social-x-twitter': xIcon,
    'social-youtube': youTubeIcon,
}

const socialMedia = computed(() => {
    return props.data.map((el) => ({
        link: el.url,
        icon: iconMap[el.icon as IconType] || '',
        alt: el.icon?.split('-').slice(1).join(' '),
    }))
})
</script>

<template>
    <section>
        <p class="mb-4 font-bold">Udostępnij</p>
        <div class="flex gap-6 pl-3">
            <a
                v-for="icon in socialMedia"
                :key="icon.alt"
                :href="icon.link"
                :title="icon.alt"
                target="_blank"
            >
                <AtomImage
                    :src="icon.icon"
                    :alt="icon.alt"
                />
            </a>
        </div>
    </section>
</template>
